var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.433 14.7349C19.1454 15.6283 18.9993 16.5613 19 17.4999C19 22.4704 23.0295 26.4999 28 26.4999C29.2268 26.5019 30.4409 26.2517 31.567 25.7649C30.4005 29.3834 27.006 31.9999 23 31.9999C18.0295 31.9999 14 27.9704 14 22.9999C14 19.2964 16.2365 16.1159 19.433 14.7349Z",
    fill: "#6D5FF2",
    stroke: "#6D5FF2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.83 16H31.5L26.5 20H31.5",
    stroke: "#6D5FF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.3da399de7b9f2c01bd6ca81b24240d1c.svg";
export { ForwardRef as ReactComponent };